import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const managerConfig = [
  {
    id: 'dashboard',
    title: 'Dashboard',
    type: 'item',
    icon: <FontAwesomeIcon size="lg" icon="home" />,
    permissions: ['admin', 'editor'],
    navLink: '/dashboard',
  },
  {
    id: 'customers',
    title: 'Customers',
    type: 'item',
    icon: <FontAwesomeIcon size="lg" icon="users" />,
    permissions: ['admin', 'editor'],
    navLink: '/customers',
  },
  {
    id: 'proposals',
    title: 'Proposals',
    type: 'item',
    icon: <FontAwesomeIcon size="lg" icon="clipboard-list" />,
    permissions: ['admin', 'editor'],
    navLink: '/proposals',
  },
  {
    id: 'projects',
    title: 'Projects',
    type: 'item',
    icon: <FontAwesomeIcon size="lg" icon="poll-h" />,
    permissions: ['admin', 'editor'],
    navLink: '/projects',
  },
  {
    id: 'benchmark',
    title: 'Benchmark',
    type: 'item',
    icon: <FontAwesomeIcon size="lg" icon="archive" />,
    permissions: ['admin', 'editor'],
    navLink: '/benchmark',
  },
  {
    id: 'referrers',
    title: 'Referrers',
    type: 'item',
    icon: <FontAwesomeIcon size="lg" icon="link" />,
    permissions: ['admin', 'editor'],
    navLink: '/referrers',
  },
  {
    id: 'timesheet',
    title: 'Timesheet',
    type: 'item',
    icon: <FontAwesomeIcon size="lg" icon="clock" />,
    permissions: ['admin', 'editor'],
    navLink: '/timesheet',
  },
];

const superConfig = [...managerConfig];

const navigationConfig = (role, userTitles = []) => {
  const titlesArray = Array.isArray(userTitles) ? userTitles : [];
  const hasDataAcqTitle = titlesArray.includes('Data Acquisition Manager');
  const isSuperRole = role === 'SUPER';
  
  
  let config = [];
  switch (role) {
    case 'Manager':
      config = managerConfig;
      break;
    case 'Super':
      config = superConfig;
      break;
    default:
      config = managerConfig;
  }
  
  // Filter out referrers if user doesn't have access
  if (!hasDataAcqTitle && !isSuperRole) {
    config = config.filter(item => item.id !== 'referrers');
  }
  
  return config;
};

export default navigationConfig;
